import React from "react";
import Layout from "../Layout";
import ProductsListContent from "../../../widgets/operator/scripts/ProductsListContent/index.js";

function Scripts(props) {
  return (
    <Layout>
      <ProductsListContent />
    </Layout>
  );
}

export default Scripts;
